import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useError } from '../providers/useError';

interface Options<T> {
  queryKey: (string | number | undefined)[];
  queryFn: () => Promise<T>;
  enabled?: boolean;
  onError?: (error: AxiosError) => void;
  initialData?: T;
}

export const useBackendData = <T>({ queryKey, queryFn, enabled, onError, initialData }: Options<T>) => {
  const { handleError } = useError();
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey,
    queryFn,
    enabled: enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: false,
    initialData,
  });

  useEffect(() => {
    if (isError) {
      if (onError) onError(error as AxiosError);
      else handleError(error as AxiosError);
    }
  }, [isError]);

  return { data, isLoading, isError, refetch };
};
